import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Image, ListGroup, Row } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaCaretRight } from "react-icons/fa";
import { IoEyeOutline } from "react-icons/io5";
import {
    PiLockKey,
    PiCamera,
    PiSealCheck,
    PiWarningCircle,
    PiInfo,
    PiUploadSimple,
} from "react-icons/pi";
import { FiEdit } from "react-icons/fi";
import { actionCommon, actionDoctor } from "../../../redux/actions";
import { ProfileCommonPage } from "../../../commonPage/profilePage";
import {
    Buttton,
    Cards,
    Inputs,
    Modaal,
    NavAndTabs,
} from "../../../components";
import PersonalInformation from "./personalInformation";
import AdditionalInformation from "./additionalInformation";
import { useAlert, useToast } from "../../../contexts";

const ProfilePage = ({ loginData }) => {
    const { t } = useTranslation();
    const { id } = useParams();
    const { showAlert } = useAlert();
    const { showToast } = useToast();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState("");
    const [previewImage, setPreviewImage] = useState(loginData.profileImage);

    const [credentials, setCredentials] = useState({
        imgData: "",
        userGuid: loginData.userGuid
    });

    const [credentials1, setCredentials1] = useState({
        userId: loginData.userGuid,
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
    });

    useEffect(() => {
        dispatch(actionDoctor.getProfileInfo(loginData.userGuid));
        dispatch(actionDoctor.getAdditionalInfo(loginData.userGuid));
    }, [dispatch, loginData]);
    const getProfileInfoData = useSelector(
        (state) => state.doctor.getProfileInfoData?.data
    );

    const getAdditionalInfoData = useSelector(
        (state) => state.doctor.getAdditionalInfoData?.data
    );
    const [activeTab, setActiveTab] = useState(id || "personal-information");

    const onTabChange = (tabId) => {
        setActiveTab(tabId);
        navigate(`/doctor/my-profile/${tabId}`);
    };
    useEffect(() => {
        setActiveTab("personal-information");
    }, []);

    const [isEditVisible, setIsEditVisible] = useState(false);

    const handleEditToggle = () => {
        setIsEditVisible((prevState) => {
            const newState = !prevState;
            if (newState) {
                showAlert("secondary", t("doctor.my_profile.enable_personal_additional"), `${t("Edit")} !`);
            }
            return newState;
        });
    };

    const handleShowModal = (type) => {
        setShowModal(true);
        setModalType(type);
    };

    const handleFormClick = (e) => {
        if (!isEditVisible) {
            e.preventDefault();
            showAlert(
                "secondary",
                t("doctor.my_profile.edit_disabled_warning"),
                `${t("note")} !`
            );
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials1((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const uploadProfileImageChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                setPreviewImage(event.target.result);
                const base64String = event.target.result.replace(/^data:image\/[a-zA-Z]+;base64,/, "");

                setCredentials((prev) => ({
                    ...prev,
                    imgData: base64String
                }));


            };

            reader.readAsDataURL(file);
        }
    };
    const handleSave = () => {
        dispatch(
            actionCommon.profileImage(credentials, (error, response) => {
                if (error) {
                    if (error.data) {
                        if (error.data.statusCode === 400) {
                            if (error.data.error && error.data.error.ValidationErrors) {
                                error.data.error.ValidationErrors.forEach((validationError) => {
                                    console.error(
                                        `${t("Field")}: ${validationError.Field} - ${t(
                                            "Message"
                                        )}: ${validationError.Message}`
                                    );

                                    showAlert(
                                        "danger",
                                        validationError.Message,
                                        `${t("Error")} : ${validationError.Field}`
                                    );
                                });
                            } else {
                                showAlert(
                                    "danger",
                                    `${t("Invalid_credentials")}`,
                                    `${t("Error")} !`
                                );
                            }
                        } else {
                            // showAlert("danger", `${t("unexpected_error")}``${t("Error")} !`);
                        }
                    }
                } else if (response) {
                    if (response.status === 200) {
                        showToast(
                            t("success"),
                            t("doctor.my_profile.profile_image_updated"),
                            5000,
                            true,
                            "top-end toast-success"
                        );
                        dispatch(actionDoctor.getProfileInfo(loginData.userGuid));
                        setShowModal(false)
                    }
                }
            })
        );
    };
    const handleResetPassword = () => {
        dispatch(
            actionCommon.changePassword(
                credentials1, (error, response) => {
                    if (error) {
                        if (error.data) {
                            if (error.data.statusCode === 400) {
                                if (error.data.error && error.data.error.ValidationErrors) {
                                    error.data.error.ValidationErrors.forEach((validationError) => {
                                        console.error(
                                            `${t("Field")}: ${validationError.Field} - ${t(
                                                "Message"
                                            )}: ${validationError.Message}`
                                        );

                                        showAlert(
                                            "danger",
                                            validationError.Message,
                                            `${t("Error")} : ${validationError.Field}`
                                        );
                                    });
                                } else {
                                    showAlert(
                                        "danger",
                                        `${t("Invalid_credentials")}`,
                                        `${t("Error")} !`
                                    );
                                }
                            } else {
                                showAlert("danger", `${t("unexpected_error")}``${t("Error")} !`);
                            }
                        }
                    } else if (response) {
                        if (response.status === 200) {
                            showToast(
                                t("success"),
                                t("doctor.my_profile.password_reset_success"),
                                5000,
                                true,
                                "top-end toast-success"
                            );
                            setShowModal(false)
                        }
                    }
                }
            )
        )
    };

    const profileCardData = [
        {
            header: t("profile_page.title"),
            content: (
                <ListGroup variant="flush">
                    <ListGroup.Item
                        className="exado-title-six"
                        onClick={() => handleShowModal("Change-Profile-Picture")}
                    >
                        <PiCamera />
                        {t("doctor.profile_page.Change_Profile_Picture")}
                    </ListGroup.Item>
                    <ListGroup.Item
                        className="exado-title-six"
                        onClick={() => handleShowModal("Change-Password")}
                    >
                        <PiLockKey />
                        {t("doctor.profile_page.Change_Password")}
                    </ListGroup.Item>
                    <ListGroup.Item className="exado-title-six">
                        <IoEyeOutline />
                        {t("doctor.profile_page.View_As_Patient")}
                    </ListGroup.Item>
                    <ListGroup.Item
                        className="exado-title-six"
                        onClick={handleEditToggle}
                    >
                        <FiEdit />
                        {t("Edit")} {t("Profile")} & {t("Additional")}
                    </ListGroup.Item>
                </ListGroup>
            ),
        },
        {
            header: t("doctor.profile_page.Profile_Info"),
            content: (
                <ListGroup variant="flush">
                    <ListGroup.Item className="exado-title-six">
                        <PiSealCheck
                            className={
                                getProfileInfoData?.result.profileVerification === 1
                                    ? "noVerify"
                                    : getProfileInfoData?.result.profileVerification === 2
                                        ? "inProcess"
                                        : getProfileInfoData?.result.profileVerification === 3
                                            ? "isVerify"
                                            : getProfileInfoData?.result.profileVerification === 4
                                                ? "noVerify"
                                                : "noVerify"
                            }
                        />
                        {t("Profile")} :{" "}
                        {getProfileInfoData?.result.profileVerification === 1
                            ? t("Not_Verified")
                            : getProfileInfoData?.result.profileVerification === 2
                                ? t("In_Process")
                                : getProfileInfoData?.result.profileVerification === 3
                                    ? t("Verified")
                                    : getProfileInfoData?.result.profileVerification === 4
                                        ? t("Rejected")
                                        : getProfileInfoData?.result.profileVerification === 5
                                            ? t("Need_additional_info")
                                            : ""}
                    </ListGroup.Item>

                    <ListGroup.Item className="exado-title-six">
                        <PiSealCheck
                            className={
                                getProfileInfoData?.result.isEmailVerified
                                    ? "isVerify"
                                    : "noVerify"
                            }
                        />
                        {t("email")} :{" "}
                        {getProfileInfoData?.result.isEmailVerified
                            ? t("Verified")
                            : t("Not_Verified")}{" "}
                    </ListGroup.Item>

                    <ListGroup.Item className="exado-title-six">
                        <PiWarningCircle
                            className={
                                getProfileInfoData?.result.isMobileVerified
                                    ? "isVerify"
                                    : "noVerify"
                            }
                        />
                        {t("Mobile")} :{" "}
                        {getProfileInfoData?.result.isMobileVerified
                            ? t("Verified")
                            : t("Not_Verified")}
                    </ListGroup.Item>
                </ListGroup>
            ),
            footer: (
                <Buttton.Buttton
                    children={
                        <>
                            {t("Send")} {t("OTP")} <FaCaretRight />
                        </>
                    }
                    className="transparent send-otp-btn"
                />
            ),
        },
        {
            header: t("doctor.profile_page.Delete_Account"),
            content: (
                <div className="exado-title-six delete-info">
                    <PiInfo />
                    <p>{t("doctor.profile_page.Delete_Account_Description")}</p>
                </div>
            ),
            footer: (
                <Buttton.Buttton
                    children={
                        <>
                            {t("DELETE")} <FaCaretRight />
                        </>
                    }
                    className="transparent del-btn"
                />
            ),
        },
    ];

    const tabs = [
        {
            id: "personal-information",
            label: t("Personal") + " " + t("Information"),
            content: (
                <PersonalInformation
                    loginData={loginData}
                    isEditVisible={isEditVisible}
                    getProfileInfoData={getProfileInfoData}
                    handleFormClick={handleFormClick}
                />
            ),
            disabled: false,
        },
        {
            id: "additional-information",
            label: t("Additional") + " " + t("Information"),
            content: (
                <AdditionalInformation
                    loginData={loginData}
                    isEditVisible={isEditVisible}
                    getAdditionalInfoData={getAdditionalInfoData}
                    handleFormClick={handleFormClick}
                />
            ),
            disabled: false,
        },
    ];

    const rightSide1 = (
        <>
            <Row className="exado-row1">
                {profileCardData.map((item, index) => (
                    <Col key={index} className="pcard-col" md={4}>
                        <Cards.Cardd
                            className="cardd"
                            header={item.header}
                            content={item.content}
                            footer={item.footer}
                        />
                    </Col>
                ))}
            </Row>

            <Row className="exado-row1">
                <Col>
                    <NavAndTabs.NavAndTabs
                        tabs={tabs}
                        activeTab={activeTab}
                        onTabChange={onTabChange}
                    />
                </Col>
            </Row>
        </>
    );

    useEffect(() => {
        const currentTab = location.pathname.split("/")[3];
        setActiveTab(currentTab || "personal-information");
    }, [location.pathname]);

    return (
        <>
            <ProfileCommonPage loginData={loginData} rightSide1={rightSide1} profileImageLink={getProfileInfoData?.result?.profileImage} />
            <Modaal.Modaal
                show={showModal}
                onHide={() => setShowModal(false)}
                title={
                    <h2 className="exado-title-nine">
                        {modalType === "Change-Profile-Picture"
                            ? t("doctor.my_profile.change_profile_picture")
                            : modalType === "Change-Password"
                                ? t("doctor.profile_page.create_new_password")
                                : ""}
                    </h2>
                }
                bodyContent={
                    modalType === "Change-Profile-Picture" ? (
                        <>
                            <figure className="uploaded-img-figure">
                                <Image src={previewImage} className="uploaded-img" />
                            </figure>
                            <Inputs.UploadFileInput
                                accept=".png, .jpg, .jpeg"
                                buttonText={
                                    <>
                                        <PiUploadSimple className="me-2" /> {t("doctor.my_profile.upload_image")}
                                    </>
                                }
                                onchange={uploadProfileImageChange}
                                className="upload-input"
                            />
                        </>
                    ) : modalType === "Change-Password" ? (
                        <p className="exado-title-six text-center mb-4">
                            {t("doctor.profile_page.password_must_be_different")}
                        </p>
                    ) : null
                }
                bodyContent1={
                    modalType === "Change-Password" ? (
                        <>
                            <Row>
                                <Inputs.FormInputs
                                    type="password"
                                    label={t("doctor.profile_page.old_password")}
                                    value={credentials1.oldPassword}
                                    name="oldPassword"
                                    onChange={handleChange}
                                    grpClassname="form-group"
                                />
                            </Row>
                            <Row className="my-4">
                                <Inputs.FormInputs
                                    type="password"
                                    label={t("doctor.profile_page.new_password")}
                                    value={credentials1.newPassword}
                                    name="newPassword"
                                    onChange={handleChange}
                                    grpClassname="form-group "
                                />
                            </Row>
                            <Row>
                                <Inputs.FormInputs
                                    type="password"
                                    label={t("doctor.profile_page.re_enter_password")}
                                    value={credentials1.confirmPassword}
                                    name="confirmPassword"
                                    onChange={handleChange}
                                    grpClassname="form-group"
                                />
                            </Row>
                        </>
                    ) : null
                }
                footer={
                    <>
                        {modalType === "Change-Profile-Picture" && (
                            <Buttton.Buttton
                                children={t("close")}
                                className="btn-border-Aqua_Teal"
                                onClick={() => setShowModal(false)}
                            />
                        )}
                        <Buttton.Buttton
                            children={
                                modalType === "Change-Password"
                                    ? t("reset_password")
                                    : t("save_changes")
                            }
                            className="btn-solid-Aqua_Teal"
                            onClick={
                                modalType === "Change-Password"
                                    ? handleResetPassword
                                    : handleSave
                            }
                        />
                    </>
                }
                centered="true"
                className={
                    modalType === "Change-Profile-Picture"
                        ? "profile-img-modal"
                        : "change-password-modal"
                }
            />
        </>
    );
};

export default ProfilePage;
